import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Modal from '../modal'
import PreviewImage from '../PreviewImage/PreviewImage'
import classes from './carousel-modal.module.sass'

const CarouselModal = ({ open, images, background }) => {
  const [index, setIndex] = useState(0)

  const increment = () => {
    setIndex((prev) => prev + 1)
  }

  return (
    <Modal open>
      <div className={classes.carousel} onClick={increment}>
        {images.map((img, i) => (
          <PreviewImage
            classes={i !== index ? classes.inactive : ''}
            foregroundUrl={img}
            backgroundUrl={background}
          />
        ))}
      </div>
    </Modal>
  )
}

CarouselModal.propTypes = {
  open: PropTypes.bool.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  background: PropTypes.string.isRequired,
}

export default CarouselModal
